import { computed } from '@angular/core';
import {
  patchState,
  signalStoreFeature,
  type,
  withComputed,
  withMethods,
  withState,
} from '@ngrx/signals';
import type { EntityId, EntityState } from '@ngrx/signals/entities';

export type SelectedEntityState = { selectedEntityId: EntityId | null };

export function withSelectedEntity<Entity>() {
  return signalStoreFeature(
    { state: type<EntityState<Entity>>() },
    withState<SelectedEntityState>({ selectedEntityId: null }),
    withComputed(({ entityMap, selectedEntityId }) => ({
      selectedEntity: computed(() => {
        const selectedId = selectedEntityId();
        return selectedId ? entityMap()[selectedId] : null;
      }),
    })),
    withMethods((store) => ({
      selectEntity: (entityId: EntityId) => {
        const availableIds = Object.keys(store.entityMap()) as EntityId[];
        if (entityId && !availableIds.includes(entityId.toString())) {
          // eslint-disable-next-line no-untranslated-string/no-untranslated-string
          throw new Error('Entity not found');
        }
        patchState(store, { selectedEntityId: entityId });
      },
      clearSelectedEntity: () => {
        patchState(store, { selectedEntityId: null });
      },
    })),
  );
}
